<template>
  <div v-if="sideShow" class="body_right">
    <div class="side_top">
      <p class="side_title">这是个名称</p>
      <p class="side_desc">这是描述</p>
    </div>
    <div class="side_bottom">
      <p class="side_title">常见问题</p>
      <div v-for="(item,index) of list" :key="index">{{item.content}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "side",
  data (){
    return{
      sideShow:true,
      list:[
        {
          name:'',
          content:'问题详情常用问题'
        },
        {
          name:'',
          content:'问题详情常用问题'
        },
        {
          name:'',
          content:'问题详情常用问题'
        },{
          name:'',
          content:'问题详情常用问题'
        },
        {
          name:'',
          content:'问题详情常用问题'
        }
      ]
    }
  },
  mounted() {
    this.sideShow = this.$store.getters.getConfigPc.side_bar;
  }
}
</script>

<style scoped>
.body_right{
  width:260px;
  border-left: .5px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 14px;
}
.side_top{
  height: 245px;
  border-bottom:.5px solid #e6e6e6;
  padding:17px 20px;
}
.side_title{
  font-size: 16px;
  color: #2a2a2c;
  margin-bottom: 10px;
}
.side_desc{
  color: #666666;
}
.side_bottom{
  flex: 1;
  padding:17px 20px;
}
.side_bottom>div{
  font-size: 14px;
  color: #666666;
  line-height: 32px;
  border-bottom: .5px solid #e6e6e6;
}
p{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/side.vue